@for (a of visibleAnnouncements(); track a.id) {
<output class="maintenance-banner" aria-live="polite" [attr.data-testid]="'maintenance-banner-' + a.id">
  <i class="pi pi-exclamation-triangle maintenance-banner__icon" aria-hidden="true"></i>
  <div class="maintenance-banner__body">
    <span class="maintenance-banner__title">{{ a.title }}</span>
    @if (a.content) {
    <span class="maintenance-banner__text">{{ a.content }}</span>
    } @if (windowLabel(a); as label) {
    <span class="maintenance-banner__window">{{ label }}</span>
    }
  </div>
  <button
    type="button"
    class="maintenance-banner__dismiss"
    (click)="onDismiss(a)"
    aria-label="Dismiss maintenance notification"
    [attr.data-testid]="'maintenance-dismiss-' + a.id"
  >
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
</output>
}
